module.exports = __webpack_public_path__ + "assets/img/Plakat3.9aac27ca.jpg";